module.exports = __webpack_public_path__ + "static/media/sre-pipe.d29ab5a6.svg";